
import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../../context/AuthContext";
import api from "../../api/api";
import Spinner from "../../components/ui/Spinner";
import MessageBox from "../../components/ui/MessageBox";
import Button from "../../components/ui/Button";
import OrderItems from "./OrderItems";

const OrderNewItem = ({ setView, context,  
   openModal, setOpenModal }) => {

  const { user } = useAuth();
  const [orderDetails, setOrderDetails] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const fetchOrderData = useCallback(async (showSpinner = true) => {
    if (showSpinner) setLoading(true);
    try {
      const orderData = await api.getOrderForEdit(context.id);
      if (orderData?.Table?.length > 0) {
        setOrderDetails({
          ...orderData.Table[0],
          Table2: orderData.Table2 || [],
        });
      }
      setOrderItems(orderData?.Table1 || []);
    } catch (err) {
      console.error(err);
      setError("Failed to load order data.");
    } finally {
      if (showSpinner) setLoading(false);
    }
  }, [context.id]);

  useEffect(() => {
    fetchOrderData();
  }, [fetchOrderData]);

  if (loading) return <Spinner />;
  if (error) return <MessageBox message={error} />;


   return (
    <div className="w-full h-full m-0 p-0 bg-white">
      <div className="p-2">
        <h1 className="text-xl font-bold text-center">
          Add Items to Order #{context.id}/ {context.customer.Vname}
        </h1>

        {success && (
          <MessageBox
            message={success}
            type="success"
            onDismiss={() => setSuccess("")}
          />
        )}

        <OrderItems
          orderId={context.id}
          customerId={context.customerId}
          orderDate={context.orderDate}
          items={orderItems}
          user={user}
          setSuccess={setSuccess}
          setError={setError}
          refetchData={() => fetchOrderData(false)}
          openModal={openModal}        // 🔹 Pass prop
          setOpenModal={setOpenModal}  // 🔹 Pass prop
          autoOpenModal={context.autoOpenModal}  // 👈 pass flag
        />

        <div className="flex justify-end pt-4 mt-4 border-t">
          <Button
            onClick={() => setView("orders")}
            className="bg-blue-500 hover:bg-blue-600 px-3 py-1 text-sm"
          >
            Back to Orders
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrderNewItem;



// import React, { useState, useEffect, useCallback } from "react";
// import { useAuth } from "../../context/AuthContext";
// import api from "../../api/api";
// import Spinner from "../../components/ui/Spinner";
// import MessageBox from "../../components/ui/MessageBox";
// import Button from "../../components/ui/Button";
// import OrderItems from "./OrderItems";

// const OrderNewItem = ({ setView, context }) => {
//   const { user } = useAuth();
//   const [orderDetails, setOrderDetails] = useState(null);
//   const [orderItems, setOrderItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   // Fetch order data
//   const fetchOrderData = useCallback(
//     async (showSpinner = true) => {
//       if (showSpinner) setLoading(true);
//       try {
//         const orderData = await api.getOrderForEdit(context.id);

//         if (orderData?.Table?.length > 0) {
//           setOrderDetails({
//             ...orderData.Table[0],
//             Table2: orderData.Table2 || [],
//           });
//         }
//         setOrderItems(orderData?.Table1 || []);
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load order data.");
//       } finally {
//         if (showSpinner) setLoading(false);
//       }
//     },
//     [context.id]
//   );

//   useEffect(() => {
//     fetchOrderData();
//   }, [fetchOrderData]);

//   if (loading) return <Spinner />;
//   if (error) return <MessageBox message={error} />;

//   return (
//     <div className="w-full h-full m-0 p-0 bg-white">
//       <div className="w-full h-full m-0 p-0">
//         <div className="p-2">
//           {/* Title */}
//           <h1 className="text-xl font-bold text-center">
//             Add Items to Order #{context.id}/ {context.customer.Vname}
//           </h1>

//           {/* ✅ Show customer info */}
//           {/* {context?.customer && (
//             <div className="text-center mb-4">
//               <p className="font-medium text-base"> {context.customer.Vname}</p>
//               <p className="font-medium text-base"> {context.customer.Mobile}</p>
//             </div>

//           )} */}

//           {success && (
//             <MessageBox
//               message={success}
//               type="success"
//               onDismiss={() => setSuccess("")}
//             />
//           )}

//           <OrderItems
//             orderId={context.id}
//             customerId={context.customerId}
//             orderDate={context.orderDate}
//             items={orderItems}
//             user={user}
//             setSuccess={setSuccess}
//             setError={setError}
//             refetchData={() => fetchOrderData(false)}
//           />

//           <div className="flex justify-end pt-4 mt-4 border-t">
//             <Button
//               type="button"
//               onClick={() => setView("orders")}
//               className="bg-blue-500 hover:bg-blue-600 px-3 py-1 text-sm"
//             >
//               Back to Orders
//             </Button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OrderNewItem;
